import { ProductPrice } from "../products/types"

export enum OfferLetterDealStageEnum {
  registrationDone = "Registration Done (Direct Enrolment)",
  offerLetterSent = "Offer Letter Sent (Direct Enrolment)",
}
export type OfferLetterType = {
  offerLetter: {
    productId: number
    content: string
    attachments: {
      id: number
      title: string
      attachment: string
    }[]
  }
  dealStage: OfferLetterDealStageEnum
  product: {
    id: number
    name: string
    slug: string
    // deliveryMode: DeliveryMode
  }
  registrationFee: ProductPrice
}
